import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
Vue.use(Vuetify);
export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#ff6600',
                secondary: '#eeab02',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#9ca09c',
                success: '#4CAF50',
                warning: '#E8C21D'
            }
        }
    }
});
